import { Model } from 'backbone';
import { ROUND_ATTRIBUTES } from './baseGame';
/**
 * @typedef {import('./baseGame.types').BaseRoundOptions} BaseRoundOptions
 */

/**
 * @template {BaseRoundOptions} RoundOptions
 * @extends {Model<RoundOptions>}
 */
export default class BaseRound extends Model {
	/** @returns {Partial<RoundOptions>} */
	defaults() {
		return {
			[ROUND_ATTRIBUTES.id]: '',
			[ROUND_ATTRIBUTES.rewards]: [],

			/** RUNTIME ATTRIBUTES */
			[ROUND_ATTRIBUTES.score]: undefined,
			[ROUND_ATTRIBUTES.selectedOptionId]: undefined,
			[ROUND_ATTRIBUTES.timesAnswered]: 0,
		};
	}
}
